import axios from "axios";
import { baseUrl } from "../constants";
//import { setBearerAuthorizationHeader } from "../../utils/interceptors";

const GetDetectionDetails = (rq) => {
    return axios
        .post(`${baseUrl()}/Detection/GetDetectionDetails`, rq)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Detection/GetDetectionDetails`, rq)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DetectionServices: Get DetectionDetails API", error);
                    });
            } else {
                console.error("DetectionServices: Get DetectionDetails API", error);
            }
        });
};

const GetClusterChart = (rq) => {
    return axios
        .post(`${baseUrl()}/Detection/GetClusterChart`, rq)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Detection/GetClusterChart`, rq)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DetectionServices: Get ClusterChart API", error);
                    });
            } else {
                console.error("DetectionServices: Get ClusterChart API", error);
            }
        });
};

const GetSearchList = (rq) => {
    return axios
        .post(`${baseUrl()}/Detection/GetSearchList`, rq)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Detection/GetSearchList`, rq)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DetectionServices: Get SearchList API", error);
                    });
            } else {
                console.error("DetectionServices: Get SearchList API", error);
            }
        });
};

const ExportWavFile = (rq) => {
    return axios
        .post(`${baseUrl()}/Detection/ExportWavFile`, rq, { responseType: 'blob' })
        .then((data) => {
            // Extract the file name from the response headers
            const disposition = data.headers.get('content-disposition');
            const matches = disposition && disposition.match(/filename=(.+)/);
            const fileName = matches && matches.length > 1 ? matches[1] : 'audio.wav';

            const blob = data.data;
            return { blob, fileName };
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Detection/ExportWavFile`, rq, { responseType: 'blob' })
                    .then((data) => {
                        // Extract the file name from the response headers
                        const disposition = data.headers.get('content-disposition');
                        const matches = disposition && disposition.match(/filename=(.+)/);
                        const fileName = matches && matches.length > 1 ? matches[1] : 'audio.wav';

                        const blob = data.data;
                        return { blob, fileName };
                    })
                    .catch((error) => {
                        console.error("DetectionServices: Export WavFile API", error);
                    });
            } else {
                console.error("DetectionServices: Export WavFile API", error);
            }
        });
};

const SaveValidation = (rq) => {
    return axios
        .post(`${baseUrl()}/Detection/SaveValidation`, rq)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Detection/SaveValidation`, rq)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DetectionServices: Save Validation API", error);
                    });
            } else {
                console.error("DetectionServices: Save Validation API", error);
            }
        });
};

const DetectionServices = { GetDetectionDetails, GetClusterChart, GetSearchList, ExportWavFile, SaveValidation };

export default DetectionServices;
